import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'

import LabelWithText from './label-with-text'

type Props = {
  birthDate?: string
}

const BirthDateWithAge = ({ birthDate }: Props) => {
  return (
    <LabelWithText
      label="Date de naissance - Âge"
      data={
        <div className="flex items-center gap-1">
          <Badge
            text={valueRender(birthDate, (date) => DateFormatter.DDMMYYYY(date))}
            variant="grey"
          />
          <Badge
            text={valueRender(birthDate, (date) => DateFormatter.calculateAge(date).toString())}
            variant="blue"
          />
        </div>
      }
      className="whitespace-nowrap"
    />
  )
}

export default BirthDateWithAge
